/**
 * Collection channel operations for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class ColChannelManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async pageColChannels(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/col_channel/page', { params });
  }

  async getColChannel(uuid: string): Promise<Record<string, any>> {
    return this.session.get(`/api/col_channel/get/${uuid}`);
  }

  async createColChannel(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/col_channel/create', { data });
  }

  async updateColChannel(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/col_channel/update', { data });
  }

  async deleteColChannel(uuid: string): Promise<Record<string, any>> {
    return this.session.post(`/api/col_channel/delete/${uuid}`);
  }

  async batchDeleteColChannels(uuids: string[]): Promise<Record<string, any>> {
    return this.session.post('/api/col_channel/batchDelete', { data: uuids });
  }

  /** Upload channel config file; server responds with a result file (blob). */
  async uploadChannelFile(formData: FormData): Promise<Blob> {
    return this.session.request('POST', '/api/cdp/col_channel/extend/upload', {
      data: formData,
      responseType: 'blob',
      timeout: 5 * 60 * 1000,
      headers: {},
    });
  }

  /** Download channel import template (blob). */
  async downloadChannelTemplate(
    protocolType: string | number,
    nodeUuid: string,
  ): Promise<Blob> {
    return this.session.request('POST', '/api/cdp/col_channel/extend/downloadTemplate', {
      data: {},
      params: { protocolType, nodeUuid },
      responseType: 'blob',
      timeout: 30 * 1000,
    });
  }
}
